/**
 * Capitaliza solo la primera letra del texto, y también
 * la primera letra después de un punto + espacio.
 * Antes convierte todo a minúsculas.
 */
const capitalizeFirstLetter = (str?: string): string => {
  if (!str) return '';

  const lower = str.toLowerCase();

  return lower.replace(/(^|[.]\s+)(\w)/g, (_, prefix, letter) => {
    return prefix + letter.toUpperCase();
  });
};

/**
 * Capitaliza cada palabra del string.
 * Antes convierte todo a minúsculas.
 */
const capitalizeEveryWord = (str?: string): string => {
  if (!str) return '';

  return str
    .toLowerCase()
    .trim()
    .split(/\s+/)
    .map((word) => word[0].toUpperCase() + word.slice(1))
    .join(' ');
};

/**
 * Elimina todos los caracteres especiales, dejando solo
 * letras, números y espacios.
 */
const removeSpecialChars = (str?: string): string => {
  if (!str) return '';

  return (
    str
      // reemplaza _ por espacio
      .replace(/_/g, ' ')
      // elimina todo lo que no sea letra, número o espacio
      .replace(/[^\p{L}\p{N} ]+/gu, '')
  );
};

const extractNumber = (value: string): string | null => {
  const match = value.match(/\d+/);
  return match ? match[0] : null;
};

const normalize = (value: string | undefined) => value?.trim().toLowerCase() ?? '';

export { capitalizeFirstLetter, capitalizeEveryWord, removeSpecialChars, extractNumber, normalize };
